import React from 'react';
import './Header.css';


function Header() {
    return (
    <>
      <div className = "nav-bar"><h1><a href = "https://github.com/swarnalii/Quotes-generator">QUOTES</a></h1></div>
    </>
    );
  }

export default Header;